import React, { useState, useEffect } from "react";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import config from "../../config";

function StudentCorrectionIX() {
  const navigate = useNavigate();

  const token = sessionStorage.getItem("secondaryAdminToken");
  const permissions = JSON.parse(sessionStorage.getItem("permissions") || "[]");

  const [loading, setLoading] = useState(false);

  const [candidateId, setCandidateId] = useState("");

  useEffect(() => {
    if (!permissions[9]?.caN_VIEW) {
      navigate("/secondary-admin-dashboard");
    }
  }, [permissions, navigate]);

  useEffect(() => {
    if (!token) {
      navigate("/secondary-admin");
    }
  }, [token, navigate]);

  // ---------------------------
  // Candidate Input Handler
  // ---------------------------
  const handleCandidateChange = (e) => {
    // allow only numbers and dash
    // const value = e.target.value.replace(/[^0-9-]/g, "");
    const value = e.target.value.toUpperCase();
    setCandidateId(value);
  };

  // ----------------------------------------------------------------------
  // API CALL ON SEARCH
  // ----------------------------------------------------------------------
  const handleSearch = async (e) => {
    e.preventDefault();

    if (!candidateId) {
      Swal.fire({
        icon: "warning",
        title: "Please Enter Candidate ID",
        // text: "Format must be XXXXX-XXXXX-XX",
      });
      return;
    }

    if (!token) {
      Swal.fire({
        icon: "error",
        title: "Unauthorized",
        text: "Please login again.",
      });
      navigate("/secondary-admin");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(
        `${config.API_BASE_URL}/AdminFetchStudentRegistrationCandidateID_CL9`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            candidatE_ID: candidateId,
            // registratioN_NO: candidateId,
          }),
        },
      );

      const data = await response.json();

      if (response.ok && data) {
        Swal.fire({
          icon: "success",
          title: "Student Found",
          timer: 1200,
          showConfirmButton: false,
        });

        navigate("/secondary-demographic-details-update-page-ix", {
          state: { studentData: data.data.student_Data },
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Not Found",
          text: data.message || "No student found with this candidate ID.",
        });
        setLoading(false);
      }
    } catch (err) {
      console.error("API Error:", err);
      Swal.fire({
        icon: "error",
        title: "Network Error",
        text: "Please check your internet connection.",
      });
      setLoading(false);
    }
  };

  return (
    <>
      <div className="container-scroller">
        {loading && (
          <div className="custom-loader-container">
            <div className="custom-loader"></div>
          </div>
        )}

        <Navbar />

        <div className="container-fluid page-body-wrapper">
          <Sidebar />

          <div className="main-panel">
            <div className="content-wrapper">
              <div className="row">
                <div className="col-md-12 mb-1">
                  <section className="content-header">
                    <h1>
                      <i className="fa fa-university" /> Student Demographic
                      Details Correction for Class IX
                    </h1>

                    <ol className="breadcrumb">
                      <li>
                        <a
                          onClick={() => navigate("/secondary-admin-dashboard")}
                          style={{ cursor: "pointer" }}
                        >
                          <i
                            className="fa fa-tachometer"
                            style={{ marginRight: 5 }}
                          ></i>
                          Home
                        </a>
                      </li>
                      <li className="active">
                        Student Correction for Class IX
                      </li>
                    </ol>
                  </section>
                </div>
              </div>

              {/* ------------------ SEARCH SECTION ------------------ */}
              <div className="row">
                <div className="card">
                  <div className="card-body">
                    <div className="row align-items-end">
                      {/* Candidate ID Input */}
                      <div className="col-md-3">
                        <label className="mb-2">Candidate ID</label>
                        <input
                          type="text"
                          className="form-control form-control-xs"
                          value={candidateId}
                          onChange={handleCandidateChange}
                          maxLength={20}
                        />
                      </div>

                      {/* Search Button */}
                      <div className="col-md-1">
                        <button
                          className="btn btn-primary"
                          style={{ marginTop: "10px" }}
                          onClick={handleSearch}
                        >
                          <i className="fa fa-search"></i> Search
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default StudentCorrectionIX;
